module.exports = __webpack_public_path__ + "static/img/short22.c81b723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/short22.png
// module id = geJo
// module chunks = 0